export default "__VITE_ASSET__DVCZPfUs__"